import React, { useState, useEffect } from 'react';
import { object, func, bool, string } from 'prop-types';

import { CloneObject } from '../../../utils/helpers';
import { useForm } from '@laramie/ui';
import { Accordion, DatePickerCustom, FormError, FormLabel, InputExpediente, InputLista, Modal } from '../../common';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';
import { useFormErrors } from '../../hooks/useFormErrors';

const HabilitacionComercioModal = (props) => {

    const entityInit = {
        id: 0,
        idComercio: 0,
        idTipoHabilitacion: 0,
        fechaHabilitacion: null,
        fechaVencimiento: null,
        resolucion: "",
        idExpediente: 0,
        detalleExpediente: ""
    };

    //hooks
    const [state, setState] = useState({
        entity: entityInit
    });

    const [formValues, formHandle, , formSet] = useForm({
        idTipoHabilitacion: 0,
        fechaHabilitacion: null,
        fechaVencimiento: null,
        resolucion: "",
        idExpediente: 0,
        detalleExpediente: ""
    });

    const mount = () => {
        formSet({
            idTipoHabilitacion: props.data.entity.idTipoHabilitacion,
            fechaHabilitacion: props.data.entity.fechaHabilitacion,
            fechaVencimiento: props.data.entity.fechaVencimiento,
            resolucion: props.data.entity.resolucion,
            idExpediente: props.data.entity.idExpediente,
            detalleExpediente: props.data.entity.detalleExpediente
        });

        setState(prevState => {
            return {...prevState, entity: props.data.entity};
        });
    }
    useEffect(mount, [props.data.entity]);

    const { errorOf, validate } = useFormErrors(getErrors);

    //handles
    const handleClickAceptar = () => {
        if (!validate()) return;

        let row = CloneObject(state.entity);
        row.idTipoHabilitacion = parseInt(formValues.idTipoHabilitacion);
        row.fechaHabilitacion = formValues.fechaHabilitacion;
        row.fechaVencimiento = formValues.fechaVencimiento;
        row.resolucion = formValues.resolucion;
        row.idExpediente = formValues.idExpediente;
        row.detalleExpediente = formValues.detalleExpediente;
        props.onConfirm(row);
    };

    //funciones
    function getErrors() {

        const errors = {};

        if (formValues.idTipoHabilitacion <= 0) errors.idTipoHabilitacion = VALIDATION_MESSAGE.REQUIRED_OPTION;

        if (formValues.fechaHabilitacion && formValues.fechaVencimiento
            && new Date(formValues.fechaVencimiento) < new Date(formValues.fechaHabilitacion)) {
            errors.fechaVencimiento = 'La fecha de vencimiento no puede ser anterior a la de habilitación';
        }

        return errors;
    }

    return (
        <Modal
            size="lg"
            title={(state.entity.id > 0) ? "Habilitación" : "Nueva habilitación"}
            onEscape={() => props.onDismiss()}
            body={(<>
                <div className="mb-3 col-12">
                    <Accordion title="Detalle" startOpen={true}>
                        <div className='row form-basic'>
                            <div className="col-12 col-sm-6 col-md-4">
                                <FormLabel htmlFor="idTipoHabilitacion" required>Tipo habilitación</FormLabel>
                                <InputLista
                                    name="idTipoHabilitacion"
                                    placeholder=""
                                    className={`form-control ${errorOf('idTipoHabilitacion') ? 'is-invalid' : ''}`}
                                    value={formValues.idTipoHabilitacion}
                                    onChange={formHandle}
                                    disabled={props.disabled}
                                    lista="TipoHabilitacion"
                                />
                                <FormError message={errorOf('idTipoHabilitacion')} />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4">
                                <label htmlFor="fechaHabilitacion" className="form-label">Fecha habilitación</label>
                                <DatePickerCustom
                                    name="fechaHabilitacion"
                                    placeholder=""
                                    className="form-control"
                                    value={formValues.fechaHabilitacion}
                                    onChange={formHandle}
                                    disabled={props.disabled}
                                />
                            </div>
                            <div className="col-12 col-sm-6 col-md-4">
                                <label htmlFor="fechaVencimiento" className="form-label">Fecha vencimiento</label>
                                <DatePickerCustom
                                    name="fechaVencimiento"
                                    placeholder=""
                                    className={`form-control ${errorOf('fechaVencimiento') ? 'is-invalid' : ''}`}
                                    value={formValues.fechaVencimiento}
                                    onChange={formHandle}
                                    disabled={props.disabled}
                                    minValue={formValues.fechaHabilitacion}
                                />
                                <FormError message={errorOf('fechaVencimiento')} />
                            </div>
                            <div className="col-12 col-md-6">
                                <FormLabel htmlFor="resolucion">Resolución</FormLabel>
                                <input
                                    name="resolucion"
                                    type="text"
                                    placeholder=""
                                    className="form-control"
                                    autoComplete="off"
                                    maxLength={250}
                                    value={formValues.resolucion}
                                    onChange={formHandle}
                                    disabled={props.disabled}
                                />
                            </div>
                            <div className="col-12 col-md-6">
                                <label htmlFor="idExpediente" className="form-label">Expediente</label>
                                <InputExpediente
                                    name="idExpediente"
                                    placeholder=""
                                    className="form-control"
                                    value={formValues.idExpediente}
                                    onChange={(event) => {
                                        const {target} = event;
                                        formSet({
                                            ...formValues,
                                            idExpediente: target.value,
                                            detalleExpediente: (target.row) ? target.row.detalleExpediente : ""
                                        });
                                    }}
                                    disabled={props.disabled}
                                />
                            </div>
                        </div>
                    </Accordion>
                </div>
            </>)}
            footer={!props.disabled ? (<>
                <button className="btn btn-outline-primary" data-dismiss="modal"
                        onClick={(event) => props.onDismiss()}>Cancelar
                </button>
                <button className="btn btn-primary" data-dismiss="modal"
                        onClick={(event) => handleClickAceptar()}>Aceptar
                </button>
            </>) : (
                <button className="btn back-button" data-dismiss="modal"
                        onClick={(event) => props.onDismiss()}>Volver
                </button>
            )}
            footerClassName={props.disabled ? 'f-align' : ''}
        />
    );
}

HabilitacionComercioModal.propTypes = {
    processKey: string.isRequired,
    disabled: bool,
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

HabilitacionComercioModal.defaultProps = {
    disabled: false
};

export default HabilitacionComercioModal;
